import { Component, EventEmitter, Input, Output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Dialog } from 'primeng/dialog'

import { Tsp } from '@ti/contracts'

import { TspForm } from '../../../account/contracts'
import { AccountFormComponent } from '../form/account-form.component'

@Component({
  selector: 'app-ti-launch-account-dialog',
  templateUrl: 'add-account-dialog.component.html',
  styleUrl: 'add-account-dialog.component.scss',
  imports: [Dialog, AccountFormComponent, TranslatePipe],
})
export class AddAccountDialogComponent {
  @Output() cancelled = new EventEmitter<void>()
  @Output() launched = new EventEmitter<TspForm>()

  @Input() opened = false
  @Input() processing = false
  @Input() account: Partial<Tsp> = {}
  @Input() errorMessage = ''
}
